var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"ThreeDModel",staticClass:"three-d-model"},[_c('canvas',{attrs:{"id":"c"}}),(_vm.screenshot)?_c('button',{attrs:{"id":"screenshot","type":"button"}},[_c('v-icon',[_vm._v("mdi-camera")])],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }